// extracted by mini-css-extract-plugin
export default {"head__container":"styles_head__container__rgrYM","head__arrow":"styles_head__arrow__tiNpb","head__title":"styles_head__title__LFIlm"};